
export default [{
    value: '>',
    label: 'Larger than',
}, {
    value: '>=',
    label: 'Larger than or equal',
}, {
    value: '<',
    label: 'Lower than',
}, {
    value: '<=',
    label: 'Lower than or equal',
}, {
    value: '=',
    label: 'Equal',
}, {
    value: '<>',
    label: 'Not Equal',
}, {
    value: '%',
    label: 'Contain',
}, {
    value: '!%',
    label: 'Not Contain',
}];
